const { every, reduce, get, size } = require('lodash');

const { PAYMENT_TYPE, PAYMENT_STATUS } = require('itrvl-types');

const itrvlPricing = require('itrvl-pricing');
const { getAsDinero, Dinero, rateLimits } = itrvlPricing;

const getSegmentInExclusions = segment => get(segment, 'notes.inclusions', '');

const hasPaidDeposit = itinerary => {
  // We want to check if all deposit payments have been made if we have them
  // or if the amout paid is more than the total deposit if we don't.
  return get(itinerary, 'payments') && get(itinerary, 'payments').length > 0
    ? every(get(itinerary, 'payments', []), payment => {
        switch (payment.paymentType) {
          case PAYMENT_TYPE.DEPOSIT:
            return payment.status === PAYMENT_STATUS.PAID;
          default:
            return true;
        }
      })
    : get(itinerary, 'finance.paid', 0) >= get(itinerary, 'finance.deposit', 0);
};

const hasProblem = itinerary => size(itinerary.problems) > 0;

// @todo: could be nice to use getters wrapped around itinerary for this stuff
const getCurrency = itinerary => get(itinerary, 'finance.currency', 'USD');
const getAdjustedSell = itinerary => getAsDinero(itinerary, 'finance.sell').add(getAsDinero(itinerary, 'finance.sell_fee_credit'));
const getDepositRate = itinerary => get(itinerary, 'rates.deposit', rateLimits.deposit.override);
const getAgentDeposit = itinerary => getAsDinero(itinerary, `deposits.agentTotal`);
const getSupplierDeposit = itinerary =>
  Dinero({
    amount: get(itinerary, `initialDeposit`, get(itinerary, `deposits.supplierTotal`, 0)),
    currency: get(itinerary, 'finance.currency', 'USD'),
  });
const getSupplierCost = itinerary => getAsDinero(itinerary, `costs.supplierTotal`, 0);
const getCreditRate = itinerary => get(itinerary, 'rates.credit', rateLimits.credit.default);
const getDeposit = itinerary => getAsDinero(itinerary, 'finance.deposit');
const getDepositServiceFee = itinerary => getAsDinero(itinerary, 'finance.deposit_fee_credit');
const getTotalDeposit = itinerary => getDeposit(itinerary).add(getDepositServiceFee(itinerary));
const getBalance = itinerary => getAsDinero(itinerary, 'finance.balance');
const getBalanceServiceFee = itinerary => getAsDinero(itinerary, 'finance.balance_fee_credit');
const getTotalBalance = itinerary => getBalance(itinerary).add(getBalanceServiceFee(itinerary));

const csvQuoteIds = itineraries =>
  reduce(itineraries, (ret, itinerary) => (itinerary.itinerary.quoteId ? `${ret},${itinerary.itinerary.quoteId}` : ret), '').slice(1);

module.exports = {
  getSegmentInExclusions,
  hasProblem,
  hasPaidDeposit,
  getCurrency,
  getAdjustedSell,
  getDepositRate,
  getAgentDeposit,
  getSupplierDeposit,
  getSupplierCost,
  getCreditRate,
  getDeposit,
  getDepositServiceFee,
  getTotalDeposit,
  getBalance,
  getBalanceServiceFee,
  getTotalBalance,
  csvQuoteIds,
};
